<template>
    <div class="row">
        <div class="col-12">
            <form @submit.prevent="SaveNoti()">
                <div class="form-row" style="margin-bottom: 20px;">
                    <span>{{ lang.bs_phone }}</span>
                    <label :for="phoneId" :class="['checkSwitch', 'badge badge-xs', phone_enabled ? 'badge-success' : 'badge-secondary']" >
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="phoneId" v-model="phone_enabled" />
                            <label class="iCheckswitch-label" :for="phoneId">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                    </label>
                    <select class="form-control" v-model="pref_phone" :disabled="!phone_enabled" >
                        <option value="+55">BRA +55</option>
                        <option value="+57">COL +57</option>
                        <option value="+51">PER +51</option>
                        <option value="+1">USA +1</option>
                    </select>
                    <input type="text" class="form-control" v-model="phone" id="phoneNoti" :disabled="!phone_enabled" :required="phone_enabled">
                    <label :for="wsId" style="margin-right:10px;">{{ lang.bssn_whatsapp }} </label>
                    <label :for="wsId" :class="['checkSwitch', 'badge badge-xs', show_btn_ws ? 'badge-success' : 'badge-secondary']">
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="wsId" v-model="show_btn_ws" />
                            <label class="iCheckswitch-label" :for="wsId">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                    </label>
                    <textarea class="form-control" v-model="text_ws" :disabled="!show_btn_ws" :required="show_btn_ws"></textarea>
                    <div class="alert alert-info">
                        <small>
                            The WhatsApp button will only be shown if a phone number is entered and the option is enabled. The text supports the variable <code>{{'&#123; &#123; product_name &#125; &#125;'}}</code> to include the product name in the message.
                        </small>
                    </div>
                </div>
                <div class="form-row"  style="margin-bottom: 20px;">
                    <span>{{ lang.bs_email }}</span>
                    <label :for="emailId" :class="['checkSwitch', 'badge badge-xs', email_enabled ? 'badge-success' : 'badge-secondary']" >
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="emailId" v-model="email_enabled" />
                            <label class="iCheckswitch-label" :for="emailId">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                    </label>
                    <input type="email" class="form-control" v-model="email" id="emailNoti" :disabled="!email_enabled" :required="email_enabled">
                </div>
                <div class="form-row"  style="margin-bottom: 20px;">
                    <label>{{ lang.bssn_contact_btn_text }}</label>
                    <input type="text" class="form-control" v-model="contact_btn_text">
                </div>
                <div class="form-row"  style="margin-bottom: 20px;">
                    <span style="width: 120px;">{{ lang.bssn_auto_response }}</span>
                    <label :for="autoResponseId" :class="['checkSwitch', 'badge badge-xs', autoresponse_sms ? 'badge-success' : 'badge-secondary']" >
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="autoResponseId" v-model="autoresponse_sms" />
                            <label class="iCheckswitch-label" :for="autoResponseId">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                        <span class="form-check-label-text" v-if="autoresponse_sms">{{ lang.bssn_sms }}</span>
                        <span class="form-check-label-text" v-else>{{ lang.bs_off }}</span>
                    </label>
                    <small style="margin-left: 10px; "> {{ lang.bssn_send_response }} </small>
                </div>
                <div class="form-actions">
                    <button class="btn btn-primary btn-lg" type="submit" :disabled="btnSend">{{ lang.bs_save }}</button>
                    <button type="button" class="btn  btn-lg" @click="$emit('cancel')">{{ lang.bs_cancel }}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: 'noti-bStore',
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data(){
        return {
            lang: {
                bs_phone: '',
                bssn_whatsapp: '',
                bs_email: '',
                bssn_contact_btn_text: '',
                bssn_auto_response: '',
                bssn_sms: '',
                bs_off: '',
                bssn_send_response: '',
                bs_save: '',
                bs_cancel: '',
            },
            user_id: window.master_client, // campos oculto
            org_id: window.localorgdata, // campos oculto
            email: this.value.email || '',
            email_enabled: this.value.email_enabled != null ? (this.value.email_enabled > 0 ? true : false) : false,
            emailId: `email_${Math.random().toString(36).slice(2, 8)}`,
            pref_phone: this.value.pref_phone || '+1',
            phone: this.value.phone || '',
            phone_enabled: this.value.phone_enabled != null ? (this.value.phone_enabled > 0 ? true : false) : false,
            phoneId: `phone_${Math.random().toString(36).slice(2, 8)}`,
            contact_btn_text: this.value.contact_btn_text || 'Contact',
            show_btn_ws: this.value.show_btn_ws != null ? (this.value.show_btn_ws > 0 ? true : false) : false,
            wsId: `ws_${Math.random().toString(36).slice(2, 8)}`,
            autoResponseId: `autoresponse_${Math.random().toString(36).slice(2, 8)}`,
            autoresponse_sms: this.value.autoresponse_sms != null ? (this.value.autoresponse_sms > 0 ? true : false) : false,
            text_ws: this.value.text_ws || "I'm interested in the product: *{{product_name}}* from your store.",
            activeWs: false,
            btnSend: false,
            apis: null,
        };
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        let urlApis = t.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        // console.log('rutas', t.apis)
        // If email/phone not provided via `value`, try to populate from store Org getter
        const org = this.getOrg();
        if (org) {
            if (!this.email) this.email = org.com_email || '';
            if (!this.phone) this.phone = org.com_telephone || '';
        }
    },
    methods: {
        getOrg(){
            try{
                return this.$store.getters['core/Org/orginf'] || null;
            }catch(e){
                return null;
            }
        },
        SaveNoti(){
            let t = this;
            const payload = {
                phone_enabled: t.phone_enabled ? 1 : 0,
                pref_phone: t.pref_phone,
                phone: t.phone,
                show_btn_ws: t.show_btn_ws ? 1 : 0,
                text_ws: t.text_ws,
                email_enabled: t.email_enabled ? 1 : 0,
                email: t.email,
                contact_btn_text: t.contact_btn_text,
                autoresponse_sms: t.autoresponse_sms ? 1 : 0,
            };
            this.$emit('save', payload);
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    }
}
</script>
<style scoped lang="scss">

.form-actions {
    margin-top: 12px;
    display: flex;
    gap: 8px;
}
.form-row {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;
    margin: 8px 0;
    span {
        width: 60px;
    }
    select.form-control {
        flex: auto;
        padding-left: 0px;
        padding-right: 0px;
        height: 30px;
        font-size: 12px;
        width: 80px;
    }
    input.form-control {
        flex: auto;
        width: 60%;
        height: 30px;
    }
    input#phoneNoti {
        width: 150px;
    }
    @media(max-width: 576px) {
        .form-check-label-text {
            display: none;
        }
    }
}
</style>
